import actionType from '../actions/actionTypes';
import * as tokenService from '@nexxt/common/firebase/auth/userDetails';
import {
    User,
    USER_ACCESS_TYPES,
    USER_STATUS
} from '../interface/user.interface';

export interface IAuthenticationReducer {
    user: User;
    requestingUser: boolean;
    isLoggedIn: boolean;
    userError: any;
    tenant: any;
}

interface ITenant {
    tenantId: number;
    tenantName: string;
    tenantURL: string;
}

export default function (
    state: IAuthenticationReducer = initialState,
    action
): IAuthenticationReducer {
    switch (action.type) {
        case actionType.LOGIN_REQUEST:
            return { ...state };
        // return { ...state, requestingUser: true };

        case actionType.LOGIN_SUCCESS:
            return {
                ...state,
                userError: null,
                isLoggedIn: true,
                user: action.payload
                // requestingUser: false
            };

        case actionType.LOGIN_FAILURE:
            return {
                ...state,
                userError: action.payload
                // requestingUser: false
            };

        case actionType.SET_TENANT:
            tokenService.setTenantId(action.payload.id);
            tokenService.setTenantName(action.payload.tenantName);
            tokenService.setTenantUrl(action.payload.url);
            tokenService.setTenantLevel(action.payload.tenantLevel);
            tokenService.setAvailableProjects(action.payload.availableProjects);
            return {
                ...state,
                tenant: {
                    tenantId: action.payload.id,
                    tenantName: action.payload.tenantName,
                    tenantURL: action.payload.url,
                    tenantLevel: action.payload.tenantLevel,
                    availableProjects: action.payload.availableProjects
                }
            };

        case actionType.GET_TENANT:
            const user = tokenService.getUserDetails();
            return {
                ...state,
                user: user
            };

        case actionType.SET_ACCESS_TYPE:
            tokenService.setAccessType(action.payload);
            return {
                ...state
            };

        case actionType.SET_USER_DETAILS:
            setUserDetailsOnLocalStorage(action.payload);
            return {
                ...state
            };

        case actionType.CLEAR_STATE:
            // @Todo: reset userDetails from localstorage
            return {
                user: { ...initialUserDetailData },
                requestingUser: false,
                isLoggedIn: false,
                userError: null,
                tenant: { ...initialTenantData }
            };

        case actionType.UPDATE_USER_STATE:
            return {
                ...state,
                user: getUserDetailsFromLocalStorage().userDetails
            };

        default:
            return state;
    }
}

function setUserDetailsOnLocalStorage(user: any) {
    tokenService.setUserDetails(user);
}
interface IToken {
    accessToken: string;
    refreshToken: string;
}

let { userDetails } = getUserDetailsFromLocalStorage();
const tenant = getTenantFromLocalStorage();

export const initialState: IAuthenticationReducer = {
    user: userDetails,
    requestingUser: false,
    isLoggedIn: false,
    userError: null,
    tenant: tenant
};

export const initialUserDetailData: User = {
    id: -1,
    firstName: '',
    company: '',
    email: '',
    accessType: USER_ACCESS_TYPES.DEFAULT,
    accountUrl: '',
    status: USER_STATUS.ACTIVE,
    createdDate: '2020-11-18 00:30:21.113'
};

export const initialTenantData: any = {
    tenantId: 0,
    tenantName: '',
    tenantURL: '',
    tenantLevel: 0
};

function getUserDetailsFromLocalStorage(): { userDetails: User } {
    userDetails = tokenService.getUserDetails() || initialUserDetailData;

    return { userDetails };
}

function getTenantFromLocalStorage(): ITenant {
    const tenant = {
        tenantId: 0,
        tenantName: '',
        tenantURL: '',
        tenantLevel: 0
    };
    tenant.tenantId = tokenService.getTenantId() || 0;
    tenant.tenantName = tokenService.getTenantName() || '';
    tenant.tenantURL = tokenService.getTenantUrl() || '';
    tenant.tenantLevel = tokenService.getTenantLevel() || 0;
    return tenant;
}
